import { render, staticRenderFns } from "./DoughnutChartAtrativo.vue?vue&type=template&id=91bf28dc"
import script from "./DoughnutChartAtrativo.vue?vue&type=script&lang=js"
export * from "./DoughnutChartAtrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports